(function () {
'use strict';

angular
    .module('personModule')
    .directive('person', directive);
        
directive.$inject = ['personService'];

function directive(personService) {
    return {
        scope: {
            personId: '=?',
            personEmail: '=?',
            model: '=?',
            version: '=',
            layoutRatio: '=?',
            hasLoadedModel: '=?',
            isExternalUser: '=?',
            roundPicture: '&',
            highlight: '=',
            truncateSize: '@'
        },
        template: '<div ng-include="getTemplateUrl()" class="person-wrapper"></div>',
        controller: ['$scope', function ($scope) {

            $scope.useRoundPicture = $scope.roundPicture();
            $scope.truncateSize = Number($scope.truncateSize) || 30;

            $scope.getLayoutRatio = function () {
                if (_.isUndefined($scope.layoutRatio)) {
                    return {
                        photoColumn: 'col-md-3',
                        infosColumn: 'col-md-5',
                        supervisorColumn: 'col-md-4'
                    };
                }
                return _.isString($scope.layoutRatio) ? $scope.$eval($scope.layoutRatio) : $scope.layoutRatio;
            };
        }],
        link: function (scope, elem, attrs) {

            scope.getTemplateUrl = function () {
                return '/app/shared/person/personDirective-' + attrs.version + '.tpl.html';
            };

            if (_.isUndefined(scope.model)) {

                scope.$watch('personId', function (newValue, oldValue) {
                    if (newValue) {
                        personService
                            .getPersonByID(newValue)
                            .then(function (person) {
                                scope.employee = person;
                                scope.model    = person;
                                scope.hasLoadedModel = true;
                            });
                    }
                });

                scope.$watch('personEmail', function (newValue) {
                    if (newValue) {
                        personService
                            .getPersonByEmployeeEmail(newValue)
                            .then(function (person) {
								if (_.isUndefined(person) || _.isUndefined(person.ItemPersonID)){
									scope.employeeEmail = newValue;
									return;
                                }
								scope.employee = person;
								scope.model    = person;
								scope.hasLoadedModel = true;
							});
                    }
                });
            }
            else {
                scope.employee = scope.model;
            }

            scope.$watch('model', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.employee = scope.model;
                }
            });
        }
    };
}
})();